import { Component, ViewEncapsulation, Inject, ElementRef, OnInit } from "@angular/core";
import { DialogPanelComponentContent } from "@toro/common/shared/models/dialogs/DialogPanelComponentContent";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import { TrackingActions } from "@toro/common/shared/state-management/tracking/tracking.action";
import { AppState } from "@toro/common/shared/interfaces/app-state.interface";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { UsersState } from "@toro/common/shared/state-management/users/users.reducer";

@Component({
  selector: "success-aside-panel",
  templateUrl: "./success-aside-panel.component.html",
  styleUrls: ["success-aside-panel.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SuccessAsidePanelComponent extends DialogPanelComponentContent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public elementRef: ElementRef,
    private dialogReference: MatDialogRef<SuccessAsidePanelComponent>,
    private router: Router,
    private store: Store<AppState>
  ) {
    super(elementRef, true);
  }

  public redirectExternal(url: string) {
    window.location.href = `${url}`;
  }

  public redirectMyInvestments() {
    this.close(this.dialogReference, null);
    return this.router.navigateByUrl("/meus-investimentos");
  }

  public redirectStocks() {
    this.close(this.dialogReference, null);
  }
}
